$(document).ready(function () {

  bootstrap();    
  product_tabs();
  dynamic_product_spec();
  quickView();
  product_page_form();
  less_quantity_product_page_form();
  // lookinForPallerQuantity();
  custom_made_product_page_form();
  need_sample_product_page_form();
  villopro_form();
  no_price_form();

});


function bootstrap(){
  let u = window.location.href;
  $('body #shopify-section-product-template .ced-link').removeAttr('target');
  $('.quick-view-button a.quick-view').removeAttr('target');
  var sqft,
    cov_val,
    tot_boxes,
    res_cov_val;
  sqft = parseFloat($('.sqft_box').text());
  $('.product-show-form-button').removeAttr('target');
}


// function lookinForPallerQuantity(){
//   var url = 'https://villopro.com'+window.location.pathname;
//   $('.get-villopro').click(function(){
//       window.open(url,'_blank' );
//   });
// }


function selectedVariant(variants, variant_name){
  $('.qv-selected-variant #variants-dropdown option').each(function(){
    $(this).removeAttr('selected');
  });
  $('.qv-selected-variant #variants-dropdown option').each(function(){
    if($(this).val() == variant_name){
      $(this).attr('selected','selected');
    }
  });
  for(var i=0; i< variants.length; i++){
    if(variants[i].title == variant_name && variants[i].available == true){
      $('.qv-add-button').val('Order Sample').removeAttr('disabled');
    }
    else if(variants[i].title == variant_name && variants[i].available == false){
      $('.qv-add-button').val('Sold out').attr('disabled', 'true');
    }
  }
  //renderImage(variants, variant_name);
}

function renderImage(variants, variant_name){
  var variant_image;
  for(var i=0; i < variants.length; i++){
    if(variants[i].title == variant_name){
      variant_image = variants[i].featured_image.src;
    }
  }
  var image_embed = '<div><img src="' + variant_image + '"></div>';
  image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
  var html_img = "<img src='"+variant_image+"'>";
  
  $('.qv-product-images').html(image_embed);
}
function selectFirstVariant(variants){
  var count=0;
  var first_variant_id, first_variant_title;
      for(var i=0; i < variants.length; i++){
        if(variants[i].available == true && count==0){
          first_variant_title = variants[i].title;
          first_variant_id = variants[i].id;
          var selected_options= first_variant_title.split(' / ');
          $('.qv-product-options .ced-options .variant-swatch-list').each(function(){
            for(var j=0; j < selected_options.length; j++){
              var selected_opt = selected_options[j].trim();
              if($(this).attr('data-value') == selected_opt){
                $(this).find('input').attr('checked','checked');   
              }
            }
            
          });
          count++;
        }
      }
  selectedVariant(variants, first_variant_title);
}

function onChangeVariants(variants, tot_options){
  $('.variant-swatch').click(function(){
    var variant_name = [];
    var var_name = "";
    var total_options = tot_options;
    var opt_index = $(this).parents('.product-form__option').attr('data-option-index');
    var opt_value = $(this).parent().attr('data-value');
    $('.qv-product-options .ced-options .option-'+opt_index+' .variant-swatch-list').each(function(){
      $(this).find('input').removeAttr('checked');
    });
    $('.option-'+opt_index+' .variant-swatch-list').each(function(){
      if($(this).attr('data-value') == opt_value){
        $(this).find('input').attr('checked','checked');
      }
    });
    
    $('.qv-product-options .ced-options .product-form__option .variant-swatch-list').each(function(){
      if(total_options != 0 && $(this).find('input').attr('checked')){
        variant_name.push($(this).find('input').val());
        total_options--;
      }
      
	});
   
    var_name = variant_name.join(" / ");
    selectedVariant(variants, var_name);
    //console.log(tot_options, variant_name, var_name);
  });
}
function renderOptions(options, variants){
    var option_html = "<div class='ced-options product-form__variants'>";
      if(options.length >= 1){
        for(var i=0; i < options.length; i++){
          var opt_name = options[i].name;
          if(opt_name != "Title"){
            option_html += "<div class='product-form__option option-"+i+"' data-option-index='"+i+"'>\
                              <span class='product-form__option-name text--strong'>"+opt_name+"</span>";
            var opt_values = options[i].values;
            for(var j=0; j < opt_values.length; j++){
              option_html += "<div class='variant-swatch-list' data-value='"+opt_values[j]+"'>\
                                  <div class='variant-swatch'>\
                                      <input class='variant-swatch__radio product-form__single-selector' type='radio' value='"+opt_values[j]+"'>\
                                      <label class='variant-swatch__item'>\
                                          <span class='block-swatch__item-text'>"+opt_values[j]+"</span>\
                                      </label>\
                                  </div>\
                              </div>";
            }
            option_html += "</div>";
          }
        }
      }
   option_html += "</div>";
   $('.qv-product-options').html(option_html);
  
  
  var variant_html = "<div class='ced-variant-dropdown' style='display: none;'><select id='variants-dropdown'>";
  for(var i=0; i < variants.length; i++){
    variant_html +="<option value='"+variants[i].title+"' data-id='"+variants[i].id+"'>"+variants[i].title+"</option>";
  }
  variant_html += "</select></div>";
  
  $('.qv-selected-variant').html(variant_html);
  
}

function processCart(qty, var_id, selected_variant_title, selected_variant_image, selected_variant_sku) {
  jQuery.post('/cart/add.js', {
   quantity: qty,
   id: var_id,
    properties: {
      Product: selected_variant_title,
      _img: selected_variant_image,
      _sku: selected_variant_sku
    }
  },
  null,
  "json"
  ).done(function () {
   $('.qv-add-to-cart-response').addClass('success').html('<span>"' + $('.qv-product-title').text() + '" has been added to your cart.</span><a href="/cart"><strong>Click here to view your cart.</strong></a>');
    window.location.href = "/cart";
  })
  .fail(function ($xhr) {
    var data = $xhr.responseJSON;
    $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
  });
}
function quickView() {
  $(".quick-view").click(function () {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    
    var sample_delivery_time = $('.sample-product__time').val();
    var product_title = $('.product-meta__title').text();
    var selected_variant_title = $('.product-form__option select option:selected').text();
    selected_variant_title = selected_variant_title.split('-');
    
    var selected_variant_image = $('.is-selected .product-gallery__size-limiter .aspect-ratio .product-gallery__image').attr('data-img-src');
    selected_variant_image = selected_variant_image.replace('_{width}x.jpg', '_180x.jpg').replace('_{width}x.png', '_180x.png');
    console.log(product_title, selected_variant_title, selected_variant_image, sample_delivery_time);
    
    var product_handle = $('.sample-product-handle').val();
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var variants = product.variants;
      var options = product.options;
      var tot_options = options.length;
      var message = $('.quick-view-button .sample-msg').val();
      
      console.log(message);
      
      renderOptions(options, variants);
      selectFirstVariant(variants);
      onChangeVariants(variants, tot_options);
      
//       $('.selected-product-name').text(product_title);
//       $('.selected-pvariant-name').text(selected_variant_title[0]);
      $('.qv-product-msg').text(message);
      $('.qv-product-delivery-time').html("<b>Delivery time:</b> "+sample_delivery_time);
      $('.qv-product-price').text("$"+product.price/100+" / Piece");
//       $('.qv-product-description').html(desc);
      
      if(product_title.includes('MSI Collection') || product_title.includes('MSI Everlife') || product_title.includes('MSI')){
        $('.quantity').hide();
      }
      else{
        $('.quantity').show();
      }

      // $('.qv-product-title').text(product_title);
      
      $(document).on("click", ".qv-add-button", function () {
        var qty = parseInt($('.qv-quantity option:selected').val());        
        var selected_variant_sku=$('.product-meta__sku-number').text();
        var var_id = $('.qv-selected-variant #variants-dropdown option:selected').attr('data-id');
        selected_variant_title = product_title+" - "+selected_variant_title[0];
        processCart(qty, var_id, selected_variant_title, selected_variant_image, selected_variant_sku)
       // console.log(qty, id);
      });
      //console.log(product);
    });
 
    
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
//         $(document).on("click", ".qv-add-button", function () {
//           var qty = $('.qv-quantity').val();
//           var selectedOptions = '';
//           var var_id = '';
//           $('#quick-view select').each(function (i) {
//             if (selectedOptions == '') {
//               selectedOptions = $(this).val();
//             } else {
//               selectedOptions = selectedOptions + ' / ' + $(this).val();
//             }
//           });
//           jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
//             $(product.variants).each(function (i, v) {
//               if (v.title == selectedOptions) {
//                 var_id = v.id;
//                 processCart();
//               }
//             });
//           });       
//         });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};
 
function product_page_form(){
  var url=location.href;
  if(url.includes('?contact_posted=true'))
  {
    $('.show_success_message').show();
  }

  $(".product-show-form-button").click(function () {
  	if ($('#product-form-quick-view').length == 0){$("body").append('<div id="product-form-quick-view"></div>');}
    var sku=$('.product-meta__sku-number').text();
   
    $.fancybox({
      href: '#product-form-quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
         var html_form_content=$('.product_page_form').html();
          $('#product-form-quick-view').hide().html(html_form_content).css('opacity', '1').fadeIn(function () {
        });
      },
      'afterClose': function () {
        $('#product-form-quick-view').removeClass().empty();
      }
    });
  })
}

function less_quantity_product_page_form(){
  $(".less-quantity-product-show-form-button").removeAttr('target');
  var url=location.href;
  if(url.includes('?contact_posted=true'))
  {
    $('.show_success_message').show();
  }

  $(".less-quantity-product-show-form-button").click(function () {
  	if ($('#less-quantity-product-form-quick-view').length == 0){$("body").append('<div id="less-quantity-product-form-quick-view"></div>');}
    var sku=$('.product-meta__sku-number').text();
   
    $.fancybox({
      href: '#less-quantity-product-form-quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
         var html_form_content=$('.less-qty-product_page_form').html();
          $('#less-quantity-product-form-quick-view').hide().html(html_form_content).css('opacity', '1').fadeIn(function () {
        });
      },
      'afterClose': function () {
        $('#less-quantity-product-form-quick-view').removeClass().empty();
      }
    });
  })
}

function custom_made_product_page_form(){
  $(".custom-made-product-show-form-button").removeAttr('target');
  var url=location.href;
  if(url.includes('?contact_posted=true'))
  {
    $('.show_success_message').show();
  }

  $(".custom-made-product-show-form-button").click(function () {
  	if ($('#custom-made-product-form-quick-view').length == 0){$("body").append('<div id="custom-made-product-form-quick-view"></div>');}
    var sku=$('.product-meta__sku-number').text();
   
    $.fancybox({
      href: '#custom-made-product-form-quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
         var html_form_content=$('.custom-made-product_page_form').html();
          $('#custom-made-product-form-quick-view').hide().html(html_form_content).css('opacity', '1').fadeIn(function () {
        });
      },
      'afterClose': function () {
        $('#custom-made-product-form-quick-view').removeClass().empty();
      }
    });
  })
}

function need_sample_product_page_form(){
  $(".need-sample-product-show-form-button").removeAttr('target');
  var url=location.href;
  if(url.includes('?contact_posted=true'))
  {
    $('.show_success_message').show();
  }

  $(".need-sample-product-show-form-button").click(function () {
  	if ($('#need-sample-product-form-quick-view').length == 0){$("body").append('<div id="need-sample-product-form-quick-view"></div>');}
    var sku=$('.product-meta__sku-number').text();
   
    $.fancybox({
      href: '#need-sample-product-form-quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '50%',
      autoSize: true,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
         var html_form_content=$('.need-sample-product_page_form').html();
          $('#need-sample-product-form-quick-view').hide().html(html_form_content).css('opacity', '1').fadeIn(function () {
        });
      },
      'afterClose': function () {
        $('#need-sample-product-form-quick-view').removeClass().empty();
      }
    });
  })
}

function villopro_form(){
  $(".villopro-show-form-button").removeAttr('target');
  var url=location.href;
  if(url.includes('?contact_posted=true'))
  {
    $('.show_success_message').show();
  }

  $(".villopro-show-form-button").click(function () {
  	if ($('#villopro-form-quick-view').length == 0){$("body").append('<div id="villopro-form-quick-view"></div>');}
    var sku=$('.product-meta__sku-number').text();
   
    $.fancybox({
      href: '#villopro-form-quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
         var html_form_content=$('.villopro_form').html();
          $('#villopro-form-quick-view').hide().html(html_form_content).css('opacity', '1').fadeIn(function () {
        });
      },
      'afterClose': function () {
        $('#villopro-form-quick-view').removeClass().empty();
      }
    });
  })
}

function executeCartPopup(popupName) {  
  let popupString = `${popupName}-quick-view`,
    popupSelector = `#${popupName}-quick-view`,
    popupToBeExecuted = (popupName == 'faq2') ? faq2Popup: faq3Popup;
  if ($(popupSelector).length == 0){$("body").append(`<div id="${popupString}"></div>`)}
  $.fancybox({
    href: popupSelector,
    maxWidth: 1040,
    maxHeight: 600,
    fitToView: true,
    width: '75%',
    height: '70%',
    autoSize: false,
    closeClick: false,
    openEffect: 'none',
    closeEffect: 'none',
    'beforeLoad': function () {
      $('.fancybox-wrap').css('overflow', 'hidden !important');
    },
    'afterShow': function () {
        $(popupSelector).hide().html(popupToBeExecuted).css('opacity', '1').fadeIn(function () {
      });
    },
    'afterClose': function () {
      $(popupSelector).removeClass().empty();
    }
  });
}

function no_price_form() {
  $(".no-price-form-button").removeAttr('target');
  var url=location.href;
  if(url.includes('?contact_posted=true'))
  {
    $('.show_success_message').show();
  }

  $(".no-price-form-button").click(function () {
  	if ($('#no-price-form-quick-view').length == 0){$("body").append('<div id="no-price-form-quick-view"></div>');}
    var sku=$('.product-meta__sku-number').text();
   
    $.fancybox({
      href: '#no-price-form-quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '50%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        //  var html_form_content=$('.need-sample-product_page_form').html();
        $('#no-price-form-quick-view').hide().html(no_price_form_html).css('opacity', '1').fadeIn(function () {
        });
      },
      'afterClose': function () {
        $('#no-price-form-quick-view').removeClass().empty();
      }
    });
  })
}

function product_tabs(){
  $('.tab-btn').click(function() {
    $('.tab-btn').removeClass('tab-active');
    $(this).addClass('tab-active');
    var tab_name = $(this).attr('data-content');
    $('.tab-content').removeClass('content-active').addClass('ced-hide');
    $('.content-' + tab_name + '').addClass('content-active').removeClass('ced-hide');
  });
}

function dynamic_product_spec(){
  $('.block-swatch__item').click(function() {
    var default_id = $('.default-id').val();
    var url = document.URL.split("variant=")[1];

    if (typeof(url) != 'undefined' && url.length > 0) {
      $('.specs-table').addClass('ced-hide');
      $('.table-variant-' + url + '').removeClass('ced-hide');
      $('.pack-specs-table').addClass('ced-hide');
      $('.pack-table-variant-' + url + '').removeClass('ced-hide');
    } else {
      $('.specs-table').addClass('ced-hide');
      $('.table-variant-' + default_id + '').removeClass('ced-hide');
      $('.pack-specs-table').addClass('ced-hide');
      $('.pack-table-variant-' + default_id + '').removeClass('ced-hide');
    }
    setTimeout(function() {
      var urlString = window.location.href;
      var paramString = urlString.split('?')[1];
      var urlParams = new URLSearchParams(paramString);
      var variant_id = urlParams.get('variant');
      $('.specs-table').addClass('ced-hide');
      $('.table-variant-' + variant_id + '').removeClass('ced-hide');
      $('.pack-specs-table').addClass('ced-hide');
      $('.pack-table-variant-' + variant_id + '').removeClass('ced-hide');
    }, 1000);
  });

}


const copyButtons = document.querySelectorAll('.banner_code_copycode');
copyButtons.forEach(button => {
  button.addEventListener('click', function () {
    const copyId = this.getAttribute('data-id');
    const discountCodeElement = this.parentElement.querySelector('.vendor_discount_code');
    const copyCode = discountCodeElement ? discountCodeElement.textContent.trim() : '';

    navigator.clipboard.writeText(copyCode)
      .then(() => {
        const orginalText = this.textContent;
        this.textContent = 'Copied';
        this.classList.add('succesCopy');

        setTimeout(() => {
          this.textContent = orginalText;
          this.classList.remove('succesCopy');

        }, 1000);
      })
      .catch(err => {
        console.error(err);
      });

  });
});

